import React from "react";
import {Product} from "@/data/entities/menu";
import PriceTag from "@widgets/pos/order/menu/products/price/PriceTag";
import {useFulfillmentType} from "@widgets/pos/order/hooks/UseFulfillmentType";

type Props = {
    product: Product,
};

const ProductPrice = ({product}: Props) => {
    const fulfillmentType = useFulfillmentType();

    return (
        <div className={"w-full flex flex-row items-center justify-start gap-6"}>
            <PriceTag
                fulfillmentType={"TAKEAWAY"}
                active={fulfillmentType === "TAKEAWAY"}
                price={product.priceTakeaway}
            />

            <PriceTag
                fulfillmentType={"DELIVERY"}
                active={fulfillmentType === "DELIVERY"}
                price={product.price}
            />
        </div>
    );
};

export default ProductPrice;